import { z } from 'zod';

export const ChatCreateResponseSchema = z.object({
  discussionId: z.string(),
});

export type ChatCreateResponse = z.infer<typeof ChatCreateResponseSchema>;
